export const Carousel = 'atlantis-carousel';